import { Component } from '@angular/core';
import { NavbarComponent } from "../../partials/navbar/navbar.component";
import { FooterComponent } from "../../partials/footer/footer.component";
import { Title } from '@angular/platform-browser';
import { LanguageService } from '../../services/language.service';
import { FormsModule } from '@angular/forms';

import { HttpClient } from '@angular/common/http';
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxSpinnerService } from "ngx-spinner";
import * as _ from 'lodash';
import { ModalPopUpComponent } from "../../components/modal-pop-up/modal-pop-up.component";
import { PartnersCarrouselComponent } from "../../components/partners-carrousel/partners-carrousel.component";

@Component({
  selector: 'app-tire-search-page',
  standalone: true,
  imports: [NavbarComponent, FooterComponent, FormsModule, NgxSpinnerModule, ModalPopUpComponent, PartnersCarrouselComponent],
  templateUrl: './tire-search-page.component.html',
  styleUrl: './tire-search-page.component.css'
})
export class TireSearchPageComponent {

  ancho:any;
  perfil:any;
  tamano_aro:any;

  readonly_perfil:boolean = true;
  readonly_tamano_aro:boolean = true;

  ancho_opts:any = [];
  perfil_opts:any = [];
  tamano_aro_opts:any = [];
  
  category:any = 2;
  categoryInfo:any;

  productList:any = [];

  texts: any;
  constructor(private langService:LanguageService, private title:Title, private spinner: NgxSpinnerService, private http: HttpClient) {
    this.texts = this.langService.getWebisteTexts().tire_search;

    if (this.langService.getLanguage() == 'es') {
      this.title.setTitle('PRINX - Buscar Llanta | Buscador de Llantas');
    }else{
      this.title.setTitle('PRINX - Find Tire | Tire Finder');
    }
  }

  readonly utmParams = '?utm_source=prinxcr&utm_medium=referral&utm_campaign=llantas';

  search(){
    //console.log(this.ancho, this.perfil, this.tamano_aro);
    window.open(`https://mundoev.com${this.utmParams}&q=Ancho-${this.ancho.name}/Perfil-${this.perfil.name}/Aro-${this.tamano_aro.name}`, '_blank');
  }

  seeDetailPage(id:any,name:any){
    window.open(`https://mundoev.com/${id}-${name}${this.utmParams}`, '_blank');
  }

  reviewCategory(){

    const headers = {
      Authorization: 'Basic ' + btoa('YNTISFXWMTJ3LPPI3T5EUU1LJNSRHKZT:'),
      Accept: '*/*',
    };

    
    if (this.category == 3 || this.category == 4) {
      this.spinner.show();
      this.http.get(`https://mundoev.com/api/categories/?filter[id_parent]=${this.category}&display=full&output_format=JSON&sort=[name_ASC]`, { headers }).subscribe((data: any) => {
        //console.log(data);
        this.categoryInfo = data.categories;

        for (let i = 0; i < this.categoryInfo.length; i++) {
          this.http.get(`https://mundoev.com/api/images/categories/${this.categoryInfo[i].id}`, { headers, responseType: 'blob' }).subscribe((imageBlob: Blob) => {
            const reader = new FileReader();
            reader.onload = () => {
              // You can use reader.result as a data URL for the image
              this.categoryInfo[i].imageUrl = reader.result;
            };
            reader.readAsDataURL(imageBlob);
          }, (error: any) => {
            console.error('Error fetching category image:');
          });
        }
      },
      (error: any) => {
        console.error('Error fetching categories:');
        this.spinner.hide();
      },
      () => {
        this.spinner.hide();
      });
    }
    if (this.category == 'medida') {
      
      this.getDataSizes();

    }
  }

  getDataSizes(){ 
    this.ancho_opts = [];
    this.perfil_opts = [];
    this.tamano_aro_opts = [];

    this.ancho = undefined;
    this.perfil = undefined;
    this.tamano_aro = undefined;


    

    const headers = {
      Authorization: 'Basic ' + btoa('YNTISFXWMTJ3LPPI3T5EUU1LJNSRHKZT:'),
      Accept: '*/*',
    };

    this.ancho_opts = [];
    this.perfil_opts = [];
    this.tamano_aro_opts = [];

    this.spinner.show();
    this.http.get(`https://mundoev.com/api/product_option_values?display=full&output_format=JSON`, { headers }).subscribe((data: any) => {
      //console.log(data);
        

      data.product_option_values.forEach((item:any) => {
        if (item.id_attribute_group === 1) {
          this.ancho_opts.push(item);
        }
        if (item.id_attribute_group === 2) {
          this.perfil_opts.push(item);
        }
        if (item.id_attribute_group === 3) {
          this.tamano_aro_opts.push(item);
        }
      });
    },
    (error: any) => {
      //console.error('Error fetching categories:');
      this.spinner.hide();
    },
    () => {
      this.spinner.hide();
    });

    this.getCombinations();
  }
  getCombinations() {
    const headers = {
      Authorization: 'Basic ' + btoa('YNTISFXWMTJ3LPPI3T5EUU1LJNSRHKZT:'),
      Accept: '*/*',
    };

    this.spinner.show();
    this.http.get(`https://mundoev.com/api/combinations?display=full&output_format=JSON`, { headers }).subscribe((productList: any) => {
      this.productList = productList;
      this.groupCombinations();
      //console.log(this.productList);
    }, (error: any) => {
      console.error('Error fetching category image:');
    }).add(() => {
      this.spinner.hide();
    });
  }

  groupCombinations():any{
    const grouped = _.mapValues(
      _.groupBy(this.productList.combinations, combo => combo.associations.product_option_values[0].id),
      combos => _.mapValues(
        _.groupBy(combos, c => c.associations.product_option_values[1].id),
        subCombos => _.uniq(_.map(subCombos, s => s.associations.product_option_values[2].id))
      )
    );
    //console.log(grouped);
    return grouped;
  }

  perfilOpts:any = [];
  changeAncho(){
    if (this.perfilOpts.length != 0) {
      this.perfil_opts = structuredClone(this.perfilOpts);
    }else{
      this.perfilOpts = structuredClone(this.perfil_opts);
    }

    //console.log(this.ancho);

    const groupedCombinations = this.groupCombinations();


    if (groupedCombinations && this.ancho && groupedCombinations[this.ancho.id]) {
      this.perfil_opts = [];
      
      this.perfil = undefined;
      this.tamano_aro = undefined;

      this.readonly_perfil = true;
      this.readonly_tamano_aro = true;

      Object.keys(groupedCombinations[this.ancho.id]).map(id_perfil => {
        //console.log(id_perfil);
        //console.log(this.perfilOpts)
        if (this.perfilOpts.find((item:any) => item.id == id_perfil)) {
          this.perfil_opts.push(this.perfilOpts.find((item:any) => item.id == id_perfil));
        }
      });
    }

    if (this.ancho != undefined ) {
      this.readonly_perfil = false; 
    }

  }

  tamanoAroOpts:any = [];
  changePerfil(){
    if (this.tamanoAroOpts.length != 0) {
      this.tamano_aro_opts = structuredClone(this.tamanoAroOpts);
    }else{
      this.tamanoAroOpts = structuredClone(this.tamano_aro_opts);
    }

    //console.log(this.perfil);

    const groupedCombinations = this.groupCombinations();


    if (groupedCombinations && this.perfil && groupedCombinations[this.ancho.id][this.perfil.id]) {
      this.tamano_aro_opts = [];
      groupedCombinations[this.ancho.id][this.perfil.id].map((id_tamanoAro:number) => {
        //console.log(id_tamanoAro);
        //console.log(this.tamanoAroOpts)
        this.tamanoAroOpts.forEach((item:any) => {
          if (item.id == id_tamanoAro) {
            this.tamano_aro_opts.push(item);
            
          }
        })
      });
    }

    if (this.ancho != undefined ) {
      this.readonly_perfil = false; 
    }

    if (this.perfil != undefined ) {
      this.readonly_tamano_aro = false; 
    }

  }
}
